<div id="page_title" class="page-title" [ngClass]="{'position-initial': mode == 'popup_mode'}" data-toggle="tooltip" title="">
  <div class="float-top-right-spinner" *ngIf="!is_initialized">
    <span class="spinner-border" role="status"></span>
    <span class="loading-txt">{{ 'Loading...' | locale }}</span>
  </div>
  <h3 style="margin:0px;">
    {{title | locale}} {{  complement ? (complement | locale) : ''}}
  </h3>
</div>
<div style="height:32px; margin: 0px;"></div>